// extracted by mini-css-extract-plugin
export default {"container":"notification_menu-module__container--2TeBP"};